import { Contract } from "web3-eth-contract";
import Web3 from "web3";
import { ABI_JSON, CONTRACT_ID } from "../../constants";
import { BasicAbiService } from "./BasicAbiService";
import { AppError } from "../../types";

export class Web3AbiService implements BasicAbiService<Contract> {
  web3?: Web3;

  contract?: Contract;

  constructor(w3: Web3) {
    this.web3 = w3;
    this.contract = new w3.eth.Contract(ABI_JSON, CONTRACT_ID);
  }

  async mint(amount: number, amountToBn: any) {
    // @ts-ignore
    const wallet = this.web3?.currentProvider?.selectedAddress;
    try {
      await this.contract?.methods?.mintSpell(amount).send({
        from: wallet,
        value: amountToBn,
      });
    } catch (e) {}
  }

  async mintRef(amount: number, amountToBn: any, ref: string) {
    // @ts-ignore
    const wallet = this.web3?.currentProvider?.selectedAddress;
    console.info("mintRef", amount, amountToBn, ref, wallet);
    try {
      await this.contract?.methods?.mintSpellRef(amount, ref).send({
        from: wallet,
        value: amountToBn,
      });
    } catch (e) {}
  }

  async mintFreeOne() {
    // @ts-ignore
    const wallet = this.web3?.currentProvider?.selectedAddress;
    try {
      await this.contract?.methods?.mintFreeOne().send({
        from: wallet,
      });
    } catch (e) {}
  }

  async getMintedCount(): Promise<number> {
    try {
      const r = await this.contract?.methods?.totalSupply().call();
      return r;
    } catch (e) {
      console.info("err", e);
      throw new Error(AppError.UnrecognizedError);
    }
  }

  async getTokenPrice(): Promise<string> {
    return this.contract?.methods?.currentTokenPrice().call();
  }

  async isStarted() {
    try {
      const isStarted = await this.contract?.methods?.isStarted().call();
      return isStarted;
    } catch (e) {
      throw new Error(AppError.UnrecognizedError);
    }
  }
}
